import React, { ButtonHTMLAttributes } from "react";
import Avatar from "./Avatar";

type AvatarStackProps = {
    images: {
        src: string;
        alt?: string;
    }[];
    max?: number;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export default function AvatarStack(props: AvatarStackProps) {
    const { images, max = 2, ...rest } = props;
    const remaining = images.length - max;
    const slicedImages = images.slice(0, max);
    return (
        <button className="flex items-centers gap-0" {...rest}>
            {slicedImages.map((image, index) => (
                <div
                    key={index}
                    style={{
                        ...{
                            ...(index === 0
                                ? {
                                      transform: "translateX(0px)",
                                  }
                                : {
                                      transform: `translateX(-${(index + 1) * 6}px)`,
                                  }),
                        },
                    }}
                    className="w-[23px] shadow-sm h-[23px] bg-transparent rounded-full border-[2px] border-white bg-white"
                >
                    <Avatar
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full rounded-full object-cover"
                    />
                </div>
            ))}

            {remaining > 0 && (
                <div
                    style={{
                        transform: `translateX(-${(slicedImages.length + 1) * 6}px)`,
                    }}
                    className="w-[24px] h-[24px] bg-[#F1F5F9] rounded-full border-[2px] border-white flex items-center justify-center"
                >
                    <p className="text-xs text-slate-500 font-rocGroteskMedium">{remaining}+</p>
                </div>
            )}
        </button>
    );
}
